import React, { useState, useEffect, useCallback } from 'react';

import styled from "styled-components";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useTranslation } from 'react-i18next';

import useWindowSize from '../global/parts/windowsSize';
import { ButtonStyle } from '../global/parts/buttons';
import projectcover from '../../images/projectcover.png';

gsap.registerPlugin(ScrollTrigger)

const ProjectsSectionStyled = styled.div`
    overflow: hidden;
    @media (min-width: 1023px) {
        .containermain{
            display: flex;
            flex-direction: column;
        }
    }
    .projectsectioncanvas {
        width: 100%;
        height: 100vh;
        background-color: var(--backgrounda);
        position: relative;
    }
    .projectpicture{
        top: 50vh;
        transform:translate(0, -50%);
        position:relative;
        background-color: var(--themecolorc);
        background-position:top top;
        background-image: url(${projectcover});
        background-size: 100%;
        background-repeat: no-repeat;
        box-sizing: border-box;
        opacity: 1;
        z-index: 1;
        object-fit: cover;
        width: 100vw;
        height: 70vh;
        box-shadow: 0 30px 40px var(--bordertext);
        @media (min-width: 1023px) {
            background-position:center center;
            position: absolute;
            width: 38vw;
            height: 70vh;
            left: var(--margin);
            border-radius: 30px;
        }
    }
    .projectcontentcontainer{
        position: relative;
        top: 0;
        right: 0;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        flex-wrap: center;
        opacity: 0;
        z-index: 5;
        padding: var(--marginhalf) var(--marginhalf) var(--marginhalf) var(--marginhalf);
        @media (min-width: 1023px) {
            top: 10vh;
            position: absolute;
            background-color: transparent;
            padding: var(--margin) var(--margin) var(--margin) 15vh;
            width: 50vw;
            height: 100vh;
        }
    }
    .projectword{
        text-align: center;
        font-size: var(--fontsizetitlec);
        font-weight: bold;
        position: relative;
        color: var(--texta);
        background-color: transparent;
        padding-bottom: 3vh;
        @media (min-width: 1023px) {
            text-align: left;
            font-size: var(--fontsizetitlea);
        }
    }
    .projectcontent{
        text-align: center;
        font-size: var(--fontsizecontentc);
        font-weight: 10;
        position: relative;
        color: var(--backgroundb);
        background-color: transparent;
        top: 7vh;
        @media (min-width: 1023px) {
            text-align: left;
        }
    }
    .button{
        position: relative;
    }
`;

function ProjectsSection() {
    const size = useWindowSize();
    const [t, i18n] = useTranslation();

    gsap.to('.projectcontentcontainer', {
        scrollTrigger: {
            markers: false,
            trigger: ".projectword",
            toogleActions: "restart pause reverse pause",
            start: "top 50%",
            end: "+=5%",
            scrub: 1,
        },
        opacity: 1,
    })

    return (
        <ProjectsSectionStyled>
            <div className="projectsectioncanvas" >
                <div className="containermain">
                    <div className="projectcontentcontainer">
                        <div className="projectcontent">
                            <div className="projectword">
                                {t('ProjectSection.title')}
                            </div>
                            <i>{t('ProjectSection.descriptiona')}</i>
                            <br />
                            {t('ProjectSection.descriptionb')}
                            <br />
                            <br />
                            <br />
                            <br />
                            <a href="/projects/">
                                <div className="button">
                                    <ButtonStyle>
                                        {t('ProjectSection.learnmore')}
                                    </ButtonStyle>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="projectpicture" />
            </div>
        </ProjectsSectionStyled>
    )
}

export default ProjectsSection;